import { Api } from './api';
import { getUseApi } from './apiProvider';

export const useApi = getUseApi<typeof Api>();
